module.exports = __webpack_public_path__ + "static/media/aeronavegacion.54cefc9c.svg";